import React from "react";
  import axios from 'axios';
  import axios2 from 'services/axios2';

  import {useParams} from "react-router-dom";
  import {Link,hashHistory} from 'react-router-dom';
  import { useNavigate } from "react-router-dom";

  import { ToastContainer, toast } from 'react-toastify';
  import  NuDropdown from "components/nubox/NuDropdown"; 
  import  NuEstado from "components/nubox/NuEstado";
  
  import { withRouterJim } from "router/withRouterJim";

  //---cutil
  import cUtilFecha from "helpers/cUtilFecha"

  import NuConfirm from "components/nubox/Box/NuConfirm";
  import { NotificationContainer, NotificationManager } from 'react-notifications';
  import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
    ToastHeader,
  } from "reactstrap";



  const cbo=[
    {  value:'1', label: 'label1'},
  ]

  const data = [
    { id_u: 1,  nom_ape: 'ALEX LIZARRAGA', }, 
  ];

  //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
  class EstudianteList extends React.Component {
    state = {

      modalActualizar: false,
      modalInsertar: false,
      form: {  id_peri: 0, 
              id_mate:0   
            },
      data: data,/* lista de datos */
      materias:[],

      estados: [
        { value: 0, label: "Inactivo", clase:'badge bg-secondary' },
        { value: 1, label: "Activo", clase:'badge bg-success' },
      ],
      
    };
    //--------------------------------------
    constructor(props) {
      super(props);

      this.refNuConfirm = React.createRef();
    }
    //------------------
    //------------------------------------------------------
    componentDidMount() {
      //--limpiamos el array de prueba
      let user = this.props.store.user

      this.setState({data:[]});
      this.setState({
        form: {
          ...this.state.form,
          id_peri: user.id_peri,
          periodo: user.periodo,
          id_mate: 0,

        },
      });

      this.cargar_cbo();
      //this.cargar_data();
    }

    //----------------especial, actualiza valores del form -------------------------------
    handleChangeForm = (e) => {
      //requerimos la prop name='?' en cada control
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    };
    
    //-----------------
    cargar_cbo = async() => {
      let param = { }
      
      await axios2.post("cbo_materia", param).then(res => {
          if(res.data.length>0){ 
            this.setState({ materias: res.data});    
            
            this.setState({form:{...this.state.form, id_mate: 0  }});
            /*let id_mate = parseInt(res.data[0].value)
            this.setState({form:{...this.state.form, id_mate: id_mate  }});*/
          }else{
            this.setState({ materias: []});            
            this.setState({form:{...this.state.form, id_mate: 0}});
          }
      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
      });
    };
    //--------------------------
    //====================================================== 
    //----cargamos los datos desde la base de datos
    cargar_data = () => {
      let user = this.props.store.user

      let param = { 
        id_peri: user.id_peri,
        id_mate : this.state.form.id_mate
      }
      console.log(param)
      axios2.post("progra_crud_get_list", param)
      .then(res => {
          if(res.data.length>0){ 
              this.setState({data: res.data});
          }else{
            this.setState({data: []});
            //  NotificationManager.error("No existen datos");
          }

      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
          
      });
    };
    //--------------------------------------
    imprimir =(id_certi)=>{
      let fileURL = process.env.REACT_APP_API_URL  + "certificado_reciboPDF/"+ id_certi;
      let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
      window.open(fileURL,'',windowFeatures);
    }
    //--------------------------------------
    
    /* === This is where the magic happens ==== */
    handleSubmit = event => {
      event.preventDefault();
      this.cargar_data();
    }
    //-------------
    onLinkClick = (e,item) => {
      e.preventDefault();
      this.props.navigate('/estudiante/e/'+ item.id_u);
    };
    //-------------
    eliminar_click = (item) =>{
      //--------------------------------
      this.refNuConfirm.current.show({
        message: 'Esta seguro de eliminar?',
        title: 'Confirmar',
        icon: 'fa fa-question-circle',
        classHeader: 'bg-default1 ',
        classButton: 'btn btn-danger',
        accept: () => {
          let idd = item.id_progra;
          //this.save(idd,'x');
          this.eliminar(idd)
        },
        reject: () => {
            console.log('cancel');
        },
        acceptLabel: 'Aceptar',
        rejectLabel: 'Cancelar'
      })
  
    }
    //=================== 
    eliminar =(id_progra) =>{
        
      let param = { id_progra: id_progra };
      console.log(param);

      axios2.post("progra_crud_eliminar_progra", param)
      .then(res => {
          console.log(res.data);
          if(res.data.exito === 1){ 
              toast.success(res.data.men);
              this.cargar_data();            
          }else{
              toast.error(res.data.men);
          }
      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
      });
    }
    //=================== SAVE
    save =(idd, ope) =>{
        
      let param = { idd:idd, ope:ope };
      console.log(param);

      axios2.post("estudiante_store", param)
      .then(res => {
          console.log(res.data);
          if(res.data.exito === 1){ 
              toast.success(res.data.mensaje);
              this.cargar_data();            
          }else{
              toast.error(res.data.mensaje);
          }
      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
      });
    }
    //-------------------------------------
    render() {
      
      return (
        <div>
          
          <div className="content">
            {
              //JSON.stringify(this.state.form)
            }
            {/*<!--- ------------------------------->*/}
            <div className="row">
              <div className="col-md-12">
                <h3> Programación por curso

                  <div className="btn-group pull-right">

                    {/*<Link to= { "/estudiante/n/0" } className="create-modal btn btn-info " >
                      <i className="fa fa-plus"></i> Nuevo 
                    </Link>*/}
                  </div>
                </h3>
              </div>
            </div>

            <div className="row d-flex justify-content-center">
                <div className="box box-info" style={{width: 400}}>
                  {/*<!-- /.box-header -->*/}
                  <div className="box-body pad">

                    <form onSubmit = { this.handleSubmit }>
                      
                    <table>
                      <tbody>
                        <tr>
                          <td>Materia:</td>
                          <td>
                            <NuDropdown 
                              options={this.state.materias}
                              name="id_mate"
                              value={this.state.form.id_mate}
                              onChange={this.handleChangeForm}
                              option0={true}
                              style={{ backgroundColor: 'rgb(236 236 236)'}}

                            />
                          </td>
                        </tr>
                        <tr>
                          <td>Periodo:</td>
                          <td colspan="2">
                            { this.state.form.periodo }
                          </td><td></td>
                        </tr>
                        <tr>
                          
                          <td colSpan={3} className="text-center">
                            <button type="submit" class="btn btn-default">
                              <i class="fa fa-binoculars" aria-hidden="true"></i>  Buscar
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3"><div id="divres1"></div></td>
                        </tr>
                      </tbody>
                    </table>

                   
                    </form>

                  </div>
                  {/*<!-- /.box-body -->*/}
                </div>
            </div>

            <div className="row">
                {/*<!-- box table -->*/}
                <div className="box">
                  <div className="box-header">
                    <br/>
                      <div className="col-md-12">


                        <div className="table-responsive">
                          <table className="table tabla_azul0 table-striped table-hover ">
                            <thead>
                              <tr>
                                <th>Nº</th>
                                <th style={{ width:85 }}>Cod. Pro.</th>
                                <th>C.I.</th>
                                <th>Nombre</th>
                                <th>Materia</th>
                                <th className="text-center" style={{ width:"150px" }}>
                                  Acción
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                          
                              {this.state.data.map((item,index) => (
                                <tr key={index}>
                                  <td>{ index +1 }</td>
                                  <td>{ item.id_progra}</td>
                                  <td>{ item.nro_doc}</td>
                                  <td>{ item.nomape_tmp}</td>
                                  <td>{ item.nombre}</td>
                                                                    
                                  <td>
                                    <div className='input-group1'>
                                      <Link to= { "/programacionlist/" + item.id_est  } 
                                        title="Editar" className="btn btn-warning btn-sm">
                                        <i className="fa fa-edit"></i> Editar programación
                                      </Link>
                                      &nbsp;
                                      <Button className="btn btn-danger btn-sm" 
                                        title="Eliminar" 
                                        onClick={ ()=> this.eliminar_click(item) }  >
                                        <i className="fa fa-trash"></i> Eliminar registro
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                              

                            </tbody>
                            
                            </table>
                          
                        </div>

                      </div>


                  </div>
                </div>
                {/*<!-- fin box table -->*/}

            </div>

            
            {/*<!--- ----------------- form busqueda ------------------>*/}

            {/*<!-- -------------------------------------------------->*/}

          </div>
          <ToastContainer />
          <NotificationContainer/>
          <NuConfirm   ref={ this.refNuConfirm }    />
        </div>
      );
    }
  }
    
  //------------para que soporte la funcionalidad de parametros
  export default withRouterJim(EstudianteList);

